<template>
  <div style="overflow-x: scroll">
    <br />
    <vs-row>
      <vs-spacer />
      <vs-button
        color="success"
        class="btnSub"
        @click="tableToExcel('W3C Example Table')"
        type="filled"
        >Download</vs-button
      ></vs-row
    ><br />
    <div id="table_report"></div>
    <div v-for="b in options_month" :key="b" align="center">
      <table
        :id="'testTable' + b.id"
        style="width: 100%"
        summary="Code page support in different versions of MS Windows."
        rules="groups"
        frame="hsides"
        border="2"
      >
        <tbody align="center">
          <tr>
            <td colspan="20">
              Electric consumption (kW-h) of Utility substation
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Month :</td>
            <td>{{ b.text }}</td>
            <td>2022</td>
            <td colspan="16"></td>
          </tr>
          <tr>
            <td rowspan="3">Date</td>
            <td colspan="2">Main</td>
            <td colspan="2">Sub Contact No.1</td>
            <td colspan="2">Sub Contact No.2</td>
            <td colspan="2">Sub Contact No.3</td>
            <td colspan="2">Sub Contact No.4</td>
            <td colspan="2">Chemical Building</td>
            <td colspan="2">Future</td>
            <td colspan="2">Future</td>
            <td colspan="2">Future</td>
            <td></td>
          </tr>
          <tr>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Recording</td>
            <td>Exiting</td>
            <td>Total</td>
          </tr>
          <tr>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
            <td>data</td>
            <td>cons.</td>
          </tr>
          <tr v-for="i in 10" :key="i" align="center">
            <td>{{ i }}</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Sum</td>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>%</td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td></td>
          </tr>

          <tr>
            <td colspan="20">&nbsp;</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td rowspan="3"></td>
            <td rowspan="3"></td>
            <td rowspan="3"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Reporter</td>
            <td>SV</td>
            <td>Div Mgr</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
    </div>
    <br />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { read, utils, writeFileXLSX } from "xlsx";
export default {
  props: {
    select_duration: String,
    select_plan: String,

    items: Array,
    select_year: Number,
    data_text: Array,
  },
  data: () => ({
    table: "testTable",
    name: "W3C Example Table",
    data_sensor: [],
    options_month: [
      // { text: "1 day", value: 1 },
      { text: "January", value: "01", id: 1 },
      { text: "February", value: "02", id: 2 },
      { text: "March", value: "03", id: 3 },
      { text: "April", value: "04", id: 4 },
      { text: "May", value: "05", id: 5 },
      { text: "June", value: "06", id: 6 },
      { text: "July", value: "07", id: 7 },
      { text: "August", value: "08", id: 8 },
      { text: "September", value: "09", id: 9 },
      { text: "October", value: "10", id: 10 },
      { text: "November", value: "11", id: 11 },
      { text: "December", value: "12", id: 12 },
    ],
    items: [],
  }),
  methods: {
    tableToExcel(name1) {
     

      console.log(this.options_month[0].value);

      const wb = { SheetNames: [], Sheets: {} };
      this.options_month.forEach((value, index) => {
        wb.SheetNames.push(value.text);
        wb.Sheets[value.text] = XLSX.utils.table_to_book(
          document.getElementById("testTable" + value.id)
        ).Sheets.Sheet1;
      });

      const blob = new Blob(
        [this.s2ab(XLSX.write(wb, { bookType: "xlsx", type: "binary" }))],
        {
          type: "application/octet-stream",
        }
      );
      var link = document.createElement("a");

      link.href = window.URL.createObjectURL(blob);
      link.download =
        reName +
        "Report in " +
        this.data_text.week +
        " " +
        this.data_text.month +
        " " +
        this.data_text.year +
        ".xlsx";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  mounted() {
    console.log(this.select_duration);
  },
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid #111111;
  border-collapse: collapse;
  font-size: 15px;
}
/* td, th {
	padding: 3px;
	width: 30px;
	height: 25px;
} */
th {
  background: #f0e6cc;
}
.even {
  background: #fbf8f0;
}
.odd {
  background: #fefcf9;
}
.btnSub {
  width: 100px;
  border-radius: 20px;
}
.cardRadi {
  border-radius: 20px;
}
</style>